// --------------------------------------------
// Smooth Scroll - DeSight Shopify Theme
// --------------------------------------------
// Smooth scrolling mit benutzerdefiniertem Easing
// für alle Anker-Links mit href="#..."
// --------------------------------------------

import { $, $$ } from '../utils/helpers.js';

const SCROLL_OFFSET = 150;

function easeInOutCubic(t) {
  return t < 0.5
    ? 4 * t * t * t
    : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function smoothScrollTo(targetElement) {
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition - SCROLL_OFFSET;
  const duration = Math.min(Math.abs(distance) * 0.5, 1000);

  if (duration <= 0) {
    window.scrollTo(0, targetPosition - SCROLL_OFFSET);
    return;
  }

  let startTime = null;
  let animationFrame;

  function animation(currentTime) {
    if (!startTime) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easeProgress = easeInOutCubic(progress);

    window.scrollTo(0, startPosition + distance * easeProgress);

    if (progress < 1) {
      animationFrame = requestAnimationFrame(animation);
    }
  }

  animationFrame = requestAnimationFrame(animation);
}

function handleAnchorClick(e) {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;

  const href = anchor.getAttribute('href');

  if (href === '#' || href.length <= 1) return;

  const target = $(href);
  console.log('[SmoothScroll] clicked:', href, 'target:', target);

  if (target) {
    e.preventDefault();
    e.stopPropagation();

    smoothScrollTo(target);

    if (history.pushState) {
      history.pushState(null, '', href);
    }
  } else {
    console.warn('[SmoothScroll] target not found:', href);
  }
}

export function initSmoothScroll() {
  document.addEventListener('click', handleAnchorClick);

  if (window.location.hash) {
    const target = $(window.location.hash);
    if (target) {
      setTimeout(() => smoothScrollTo(target), 100);
    }
  }
}
